/**
 * Storage refused to hand over a file's contents: its presigned GET was
 * answered with an error status.
 *
 * Carries the status so a caller can report it against the file's path, which
 * the file service does not know.
 */
export class FileDownloadError extends Error {
  public readonly fileId: string;
  public readonly status: number;

  constructor(fileId: string, status: number) {
    super(`Could not download file ${fileId} (${status})`);
    this.name = "FileDownloadError";
    this.fileId = fileId;
    this.status = status;
  }
}
